"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subheading1 = Subheading1;
exports.Subheading2 = Subheading2;
exports.Body = Body;
exports.Lead = Lead;
exports.Caption = Caption;
exports.Super2 = exports.Super1 = exports.Heading4 = exports.Heading3 = exports.Heading2 = exports.Heading1 = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _index = require("../../index");

var _helpers = require("../../common/helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // Page headings are set in this style.


var Heading1 = (0, _helpers.htmlElement)('h1', _index.Classes.HEADING); // Secondary headings are set in this style.

exports.Heading1 = Heading1;
var Heading2 = (0, _helpers.htmlElement)('h2', _index.Classes.HEADING); // Tertiary headings are set in this style.

exports.Heading2 = Heading2;
var Heading3 = (0, _helpers.htmlElement)('h3', _index.Classes.HEADING);
exports.Heading3 = Heading3;
var Heading4 = (0, _helpers.htmlElement)('h4', _index.Classes.HEADING); // Used to show data in charts and other components with high emphasis.

exports.Heading4 = Heading4;
var Super1 = (0, _helpers.htmlElement)('div', _index.Classes.SUPERHEADING1); // Used to show data in charts and other components with lower emphasis.

exports.Super1 = Super1;
var Super2 = (0, _helpers.htmlElement)('div', _index.Classes.SUPERHEADING2); // Usages include primary navigation, primary/secondary buttons, and card titles.

exports.Super2 = Super2;

function Subheading1(_ref) {
  var className = _ref.className,
      muted = _ref.muted,
      tagName = _ref.tagName,
      props = _objectWithoutProperties(_ref, ["className", "muted", "tagName"]);

  var classes = (0, _classnames.default)(_defineProperty({}, _index.Classes.TEXT_MUTED, muted), _index.Classes.SUBHEADING1, className);
  var Component = (0, _helpers.htmlElement)(tagName || 'div', classes);
  return /*#__PURE__*/React.createElement(Component, props);
} // Usages include input field titles, tertiary buttons and chips.


function Subheading2(_ref2) {
  var className = _ref2.className,
      muted = _ref2.muted,
      tagName = _ref2.tagName,
      props = _objectWithoutProperties(_ref2, ["className", "muted", "tagName"]);

  var classes = (0, _classnames.default)(_defineProperty({}, _index.Classes.TEXT_MUTED, muted), _index.Classes.SUBHEADING2, className);
  var Component = (0, _helpers.htmlElement)(tagName || 'div', classes);
  return /*#__PURE__*/React.createElement(Component, props);
} // Usages include paragraph text, navigation and input fields.


function Body(_ref3) {
  var _classNames3;

  var bold = _ref3.bold,
      className = _ref3.className,
      intent = _ref3.intent,
      muted = _ref3.muted,
      semiBold = _ref3.semiBold,
      tagName = _ref3.tagName,
      props = _objectWithoutProperties(_ref3, ["bold", "className", "intent", "muted", "semiBold", "tagName"]);

  var classes = (0, _classnames.default)((_classNames3 = {}, _defineProperty(_classNames3, _index.Classes.TEXT_MUTED, muted), _defineProperty(_classNames3, _index.Classes.TEXT_BOLD, bold), _defineProperty(_classNames3, _index.Classes.TEXT_SEMI_BOLD, semiBold), _defineProperty(_classNames3, _index.Classes.intentClass(intent), intent), _classNames3), _index.Classes.BODY_TEXT, className);
  var Component = (0, _helpers.htmlElement)(tagName || 'div', classes);
  return /*#__PURE__*/React.createElement(Component, props);
} // Typical usage would be for paragraph text where there is not much other copy present,
// or as an introduction paragraph with further text.
// tslint:disable-next-line:no-empty-interface


function Lead(_ref4) {
  var className = _ref4.className,
      muted = _ref4.muted,
      tagName = _ref4.tagName,
      props = _objectWithoutProperties(_ref4, ["className", "muted", "tagName"]);

  var classes = (0, _classnames.default)(_defineProperty({}, _index.Classes.TEXT_MUTED, muted), _index.Classes.LEAD, className);
  var Component = (0, _helpers.htmlElement)(tagName || 'div', classes);
  return /*#__PURE__*/React.createElement(Component, props);
}

function Caption(_ref5) {
  var _classNames5;

  var className = _ref5.className,
      intent = _ref5.intent,
      muted = _ref5.muted,
      tagName = _ref5.tagName,
      props = _objectWithoutProperties(_ref5, ["className", "intent", "muted", "tagName"]);

  var classes = (0, _classnames.default)((_classNames5 = {}, _defineProperty(_classNames5, _index.Classes.TEXT_MUTED, muted), _defineProperty(_classNames5, _index.Classes.intentClass(intent), intent), _classNames5), _index.Classes.CAPTION, className);
  var Component = (0, _helpers.htmlElement)(tagName || 'div', classes);
  return /*#__PURE__*/React.createElement(Component, props);
}